import React from "react";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {Allow, policyEvents} from "../../../../Components/Authorize";
import {getLoanLibraryMediaFormatTextByValue} from "../loanLibraryConstants";
import {getAvailabilityStatus, renderCatalogDetail} from "../loanLibraryCatalogUtilities";
import {CatalogItemImage} from "./CatalogItemImage";

interface LoanLibraryCatalogItemProps {
    author?: string;
    description?: string;
    handleClickEdit?: () => void;
    handleClickAddToQueue?: () => void;
    loanLibraryCatalogId?: string;
    mediaFormat?: number;
    productImageUrl?: string | null;
    productName?: string;
    quantityCurrentlyAvailable?: number;
    totalQuantity?: number;
    [key: string]: unknown;
}

export const LoanLibraryCatalogItem = ({
                                           author,
                                           description,
                                           handleClickEdit,
                                           handleClickAddToQueue,
                                           loanLibraryCatalogId,
                                           mediaFormat,
                                           productImageUrl,
                                           productName,
                                           quantityCurrentlyAvailable,
                                           totalQuantity,
                                       }: LoanLibraryCatalogItemProps) => {

    const availabilityStatus = getAvailabilityStatus(quantityCurrentlyAvailable ?? 0, totalQuantity ?? 0);
    const isAvailable = (quantityCurrentlyAvailable ?? 0) > 0;

    return (
        <div className="catalog-item">
            <div className="catalog-item__title-row">
                <h3 id={`title${loanLibraryCatalogId}`}>
                    {productName}
                </h3>
                <div className="catalog-item__title-actions">
                    <span className="catalog-item__availability">{availabilityStatus}</span>
                    {
                        handleClickAddToQueue &&
                        <ButtonLinkStyle
                            label={isAvailable ? "Add to Queue" : "Add to Waitlist"}
                            name={`btnAddQueue${loanLibraryCatalogId}`}
                            onClick={handleClickAddToQueue}
                        />
                    }
                    {
                        handleClickEdit &&
                        <Allow policyEvent={policyEvents.MANAGE_LOAN_LIBRARY_CATALOG}>
                            <ButtonLinkStyle
                                label={`Edit Item`}
                                name={`btnEdit${loanLibraryCatalogId}`}
                                onClick={handleClickEdit}
                            />
                        </Allow>
                    }
                </div>
            </div>
            <div className="catalog-item__details-row">
                <CatalogItemImage imageUrl={productImageUrl} productName={productName} />
                <div className="catalog-item__info">
                    {renderCatalogDetail(author, "Author")}
                    {renderCatalogDetail(getLoanLibraryMediaFormatTextByValue(mediaFormat), "Media Format")}
                    {renderCatalogDetail(description, "Description")}
                </div>
            </div>
        </div>
    );
};

